import {CommonModule} from '@angular/common';
import {BlockgroupWindowClosedNotificationComponent} from 'libs/faculty-performance/src/lib/components/performance-inbox/notification-space/notification-template/notifiactions/blockgroup-window-closed-notification.component';
import {LearnerBulkImportCompleteComponent} from 'libs/faculty-performance/src/lib/components/performance-inbox/notification-space/notification-template/notifiactions/learner-bulk-import-complete/learner-bulk-import-complete.component';
import {BlockgroupWindowOpenedNotificationComponent} from 'libs/faculty-performance/src/lib/components/performance-inbox/notification-space/notification-template/notifiactions/blockgroup-window-opened-notification.component';
import {FacultyBulkImportCompleteComponent} from 'libs/faculty-performance/src/lib/components/performance-inbox/notification-space/notification-template/notifiactions/faculty-bulk-import-complete/faculty-bulk-import-complete.component';

import {Component, input, Input, ViewContainerRef} from '@angular/core';
import {firstValueFrom} from 'rxjs';

import {
    NotificationFilterTypeEnum,
    NotificationStatusEnum,
    NotificationTypeEnum
} from 'libs/data-access/notification/src/lib/enums/notification-types.enum';
import {
    FacultyNotification,
    FacultyNotificationWithLink
} from 'libs/data-access/notification/src/lib/models/request-response-notification.models';
import {NotificationService} from 'libs/data-access/notification/src/lib/services/notification.service';
import {NotificationContextService} from 'libs/data-access/notification/src/lib/services/notification-context.service';

@Component({
    imports: [
        CommonModule,
        BlockgroupWindowClosedNotificationComponent,
        LearnerBulkImportCompleteComponent,
        BlockgroupWindowOpenedNotificationComponent,
        FacultyBulkImportCompleteComponent
    ],
    selector: 'notification-template',
    templateUrl: './notification-template.component.html',
    styleUrls: ['./notification-template.component.scss']
})
export class NotificationTemplateComponent {
    notificationContainer: ViewContainerRef;

    @Input() notification: FacultyNotificationWithLink;
    condensedView = input(false);

    constructor(
        private notificationService: NotificationService,
        private notificationContextService: NotificationContextService
    ) {}

    async onDeleteClick(): Promise<void> {
        const response = await firstValueFrom(
            this.notificationService.changeNotificationStatus(
                this.notification.Notification.Id,
                NotificationStatusEnum.Deleted
            )
        );

        if (response.Completed) {
            this.notification.IsActive = false;
            this.notification.IsRead = true;

            this.notificationContextService.setNotificationStatusChanged(
                this.notification,
                NotificationStatusEnum.Deleted
            );
        }
    }

    async readNotification(): Promise<void> {
        const response = await firstValueFrom(
            this.notificationService.changeNotificationStatus(
                this.notification.Notification.Id,
                NotificationStatusEnum.Read
            )
        );

        if (response.Completed) {
            this.notification.IsRead = true;
            this.notificationContextService.setNotificationStatusChanged(
                this.notification,
                NotificationStatusEnum.Read
            );
        }
    }

    takeColorClass(isBackground: boolean): string {
        const classBase = isBackground ? 'bg' : 'text';

        if (this.notification.Notification.NotificationType.CategoryId === NotificationTypeEnum.Tasks) {
            return classBase + '-success';
        } else if (this.notification.Notification.NotificationType.CategoryId === NotificationTypeEnum.Insights) {
            return classBase + '-purple-light';
        } else {
            return classBase + '-warning-dark';
        }
    }

    isWindowOpened(notification: FacultyNotification): boolean {
        return (
            notification.NotificationType.Id === NotificationFilterTypeEnum.QuizWindowOpened ||
            notification.NotificationType.Id === NotificationFilterTypeEnum.AssessmentWindowOpened
        );
    }

    isWindowClosed(notification: FacultyNotification): boolean {
        return (
            notification.NotificationType.Id === NotificationFilterTypeEnum.QuizWindowClosed ||
            notification.NotificationType.Id === NotificationFilterTypeEnum.AssessmentWindowClosed
        );
    }

    isLearnerBulkImportComplete(notification: FacultyNotification): boolean {
        return notification.NotificationType.Id === NotificationFilterTypeEnum.InstitutionBulkEnrollmentComplete;
    }

    isFacultyBulkImportComplete(notification: FacultyNotification): boolean {
        return notification.NotificationType.Id === NotificationFilterTypeEnum.FacultyBulkImportComplete;
    }
}
